import * as React from 'react';

import { createRoot } from 'react-dom/client';

import App from './App';
import { initSentry } from './services';
import { initDatadog } from './services/datadog';

initSentry();
initDatadog();

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
